import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from 'swiper/modules';
import "swiper/css";
import 'swiper/css/effect-fade';
import './Home.css';
import About_Img from '../images/about.jpg';
// Portfolio
import Dreamhash from '../images/projects/dreamhash.png';
import kheeddo from '../images/projects/kheeddo.png';
import Metromedi from '../images/projects/metromedi.png';
import MSA from '../images/projects/MSA.png';
import Premier from '../images/projects/premier-pumps.jpg';
import Helishores from '../images/projects/helishores.png';
import Nichesoft from '../images/projects/nichesoft.png';
import Durgi from '../images/projects/durgi-millets.png';
import Tattva from '../images/projects/tattva.png';
import HelpMed from '../images/projects/helpmed.png';

// Services
import WebDev from '../images/services/web-dev.png';
import LogoDesign from '../images/services/logo-design.png';
import Marketing from '../images/services/marketing.png';
import SEO from '../images/services/seo.png';
// Clients
import AVRLogo from '../images/clients/avr-logo.png'
import DHLogo from '../images/clients/DH-logo.png'
import PremierUSALogo from '../images/clients/premier-usa-logo.png'
import PremierLogo from '../images/clients/premier-logo.png'
import HelishoresLogo from '../images/clients/helishores.png'
import SkandLogo from '../images/clients/skand-logo.png'
import NichesoftLogo from '../images/clients/NicheSoft-logo.png'
import kheeddoLogo from '../images/clients/kheeddo-logo.png'
import MetromediLogo from '../images/clients/Metromedi-logo.png'
import MSALogo from '../images/clients/MSA-logo.png'
import OMGLogo from '../images/clients/OMG-logo.png'
import QuatzLogo from '../images/clients/Quatz-logo.png'
import SASLogo from '../images/clients/SAS-logo.png'
import TattvaLogo from '../images/clients/tattva-logo.png'
import ZamindaarLogo from '../images/clients/Zamindaar-logo.png'
import HelpMedLogo from '../images/clients/helpmed-logo.png'
// Blogs 
import BlogOne from '../images/blogs/blog-1.jpg'
import BlogTwo from '../images/blogs/digital-marketing.png'
import BlogThree from '../images/blogs/seo.jpg'




function Home({ toggleTheme }) {

  // ✅ Put useEffect HERE — inside the component
  useEffect(() => {
    const boxes = document.querySelectorAll(".even-box");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("scrolled");
          } else {
            entry.target.classList.remove("scrolled");
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    boxes.forEach(box => observer.observe(box));

    return () => {
      boxes.forEach(box => observer.unobserve(box));
    };
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  // Logo Slider
  const logos = [
    { id: 1, src: AVRLogo, alt: "AVR" },
    { id: 2, src: DHLogo, alt: "Dreamhash" },
    { id: 3, src: TattvaLogo, alt: "Tattva" },
    { id: 4, src: PremierLogo, alt: "Premier" },
    { id: 5, src: HelishoresLogo, alt: "Helishores" },
    { id: 6, src: NichesoftLogo, alt: "Nichesoft" },
    { id: 7, src: kheeddoLogo, alt: "KHEEDDO" },
    { id: 8, src: MetromediLogo, alt: "METROMEDI" },
    { id: 9, src: MSALogo, alt: "MSA" },
    { id: 10, src: OMGLogo, alt: "OMG" },
    { id: 11, src: PremierUSALogo, alt: "PREMIER USA" },
    { id: 12, src: SkandLogo, alt: "SKAND EXIM" },
    { id: 13, src: QuatzLogo, alt: "QUATZ" },
    { id: 14, src: HelpMedLogo, alt: "Help Med Solutions" },
    { id: 15, src: SASLogo, alt: "SAS" },
    { id: 16, src: ZamindaarLogo, alt: "Zamindaar" }
  ];



  const firstHalf = logos.slice(0, Math.ceil(logos.length / 2));
  const secondHalf = logos.slice(Math.ceil(logos.length / 2));
  // Logo Slider

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const testimonials = [
    {
      text: "Thanks to Per A Cause, our online presence has flourished! Their website design and digital marketing strategies have helped us connect with more farmers and expand our reach.",
      name: "Suresh",
      company: "Srinivasa Agro Seeds",
    },
    {
      text: "Per A Cause team transformed our online presence with a stunning website and powerful digital marketing. Their expertise and speed have significantly boosted our brand visibility and engagement.",
      name: "Nithin",
      company: "One More Game",
    },
    {
      text: "Working with Per A Cause has been a game-changer for our multi-vendor business. Their expertise in website development and digital marketing has helped us attract more sellers and customers, driving remarkable growth.",
      name: "Kishan",
      company: "Kheeddo",
    },
    {
      text: "Their expertise in web development and digital marketing has helped us connect with more customers and boost our sales at MSA Motors.",
      name: "Junaid (MD)",
      company: "MSA MOTORS",
    },
  ];

  const blogs = [
    { img: BlogOne, title: "How to Make Your Website Look Great on Any Device" },
    { img: BlogTwo, title: "The Top Digital Marketing Metrics You Should Be Measuring" },
    { img: BlogThree, title: "Local SEO Strategies to Boost Your Business Visibility" }
  ];
  // Repeat the blog cards to create an infinite loop effect
  const repeatedBlogs = [...blogs, ...blogs, ...blogs];

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    const formBody = new URLSearchParams(formData).toString();

    try {
      const response = await fetch("https://peracause.com/backend-files/per-a-cause/contact-per-a-cause.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formBody,
      });

      const result = await response.json();

      if (result.status === "success") {
        setResponseMessage("Message sent successfully! ✅");
        setFormData({ firstName: "", lastName: "", email: "", phone: "", message: "" });
      } else {
        setResponseMessage("Error: " + result.message);
      }
    } catch (error) {
      setResponseMessage("Error sending message. Please try again.");
    } finally {
      setLoading(false);
    }
  };








  return (
    <div className='containter-fluid' >
      {/* Show loading animation */}
      {/* Show loading animation */}
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Sending message...</p>
        </div>
      )}
      {/* Modal with Overlay */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="">
            <div className="">
              <div className="modal-content">

                <div class="contact-form-container p-4 rounded-4">
                  <span className="close-button" onClick={toggleModal}>
                    &times;
                  </span>
                  <form id="contactForm" action="contact.php" method="POST" className="p-3" onSubmit={handleSubmit}>
                    <div class="row">
                      <div class="col-md-6 mb-3">
                        <input type="text" placeholder="First Name" class="form-control py-3 px-3 glass-background" id="firstName" name="firstName" onChange={handleChange} required />
                      </div>
                      <div class="col-md-6 mb-3">
                        <input type="text" placeholder="Last Name" class="form-control py-3 px-3 glass-background" id="lastName" name="lastName" onChange={handleChange} required />
                      </div>

                    </div>

                    <div class="row">
                      <div class=" mb-3">
                        <input type="tel" placeholder="Mobile Number" class="form-control py-3 px-3 glass-background" id="phone" name="phone" onChange={handleChange} required />
                      </div>
                      <div class=" mb-3">
                        <input type="email" placeholder="Email Address" class="form-control py-3 px-3 glass-background" id="email" name="email" onChange={handleChange} required />
                      </div>
                      {/* <div class=" mb-3">
                      <input type="text" placeholder="Subject" class="form-control py-3 px-3 glass-background" id="subject" name="subject" required />
                    </div> */}
                    </div>

                    <div class="mb-3">
                      <textarea class="form-control glass-background" placeholder="Message" id="message" name="message" rows="4" onChange={handleChange} required></textarea>
                    </div>

                    {/* <button type="submit" class="btn btn-primary">Submit</button> */}

                    <div className="row justify-content-center">
                      <div className="col-10">
                        {/* From Uiverse.io by Li-Deheng */}
                        <div className="btn-container my-3">
                          <button className="btn-content justify-content-center py-2 col-12 border-0" type="submit">
                            <span className="btn-title text-center">{loading ? "Sending..." : "SEND A MESSAGE"}</span>
                            <span className="icon-arrow">
                              <svg
                                width="30px"
                                height="30px"
                                viewBox="0 0 66 43"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                  <path
                                    id="arrow-icon-one"
                                    d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                                    fill="#FFFFFF"
                                  ></path>
                                  <path
                                    id="arrow-icon-two"
                                    d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                                    fill="#FFFFFF"
                                  ></path>
                                  <path
                                    id="arrow-icon-three"
                                    d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                                    fill="#FFFFFF"
                                  ></path>
                                </g>
                              </svg>
                            </span>
                          </button>
                        </div>

                      </div>
                    </div>

                    {responseMessage && <p>{responseMessage}</p>}
                  </form>
                </div>
              </div>
            </div>
          </div>


        </div>
      )
      }
      {/* Hero Section */}
      < section className="container-fluid hero-banner pt-50 d-flex align-items-center justify-content-center positive-relative" >
        <div className="container w-100 d-flex align-items-center justify-content-center flex-column px-lg-4 position-relative" data-aos="fade-up" data-aos-duration="1000">
          {/* Title */}
          <h2 className="mb-3 title fw-bold fs-4 text-center letter-spacing-3">
            WE ARE A CREATIVE TEAM OF
          </h2>
          <h1 className="text-center display-5 mb-4">
            Building powerful websites, driving impactful online growth, and boosting brands with expert SEO, social media marketing, and paid advertising.
          </h1>

          {/* Round Button */}
          <div className="section-btn-container" >
            <a className="section-btn-content" href="/contact">
              <span className="section-btn-title text-white">Get Started</span>
              <span className="section-icon-arrow">
                <svg
                  width="45px"
                  height="43px"
                  viewBox="0 0 66 43"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <g id="arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path
                      id="arrow-icon-one"
                      d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                      fill="#FFFFFF"
                    ></path>
                    {/* Additional arrows */}
                    <path
                      id="arrow-icon-two"
                      d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                      fill="#FFFFFF"
                    ></path>
                  </g>
                </svg>
              </span>
            </a>
          </div>

          {/* Hero Large Title */}
          <div
            className="hero-large-title col-12 position-absolute"
          >
            <h1 className="text-center fw-bold">PER A CAUSE</h1>
          </div>
        </div>
      </section >
      {/* Hero Section */}

      {/* <!-- portfolio start  --> */}

      <section className="container-fluid py-5 bg-light-gray">
        <div className="container">
          <div className="title-part d-flex align-items-center justify-content-center flex-column mb-5">
            <h2 className="mb-3 title fw-bold fs-4 text-center OUR WORK HIGHLIGHTS">OUR WORK HIGHLIGHTS</h2>
            <h2 className="text-center display-4 ">Explore Our Portfolio</h2>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-6 even-box">
              <div className="p-lg-4">
                <a className="text-decoration-none" href="https://premierpumps.net/" target="_blank">
                  <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                    <img className="img-fluid rounded-5" src={Premier} alt="" />
                  </div>
                  <div className="portfolio-text-part">
                    <h3 className="mb-3 title fw-bold fs-4 text-center">PREMIER PUMPS</h3>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 even-box">
              <div className="p-lg-4">
                <a className="text-decoration-none" href="https://helishores.com/" target="_blank">
                  <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                    <img className="img-fluid rounded-5" src={Helishores} alt="" />
                  </div>
                  <div className="portfolio-text-part">
                    <h3 className="mb-3 title fw-bold fs-4 text-center">HELISHORES</h3>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 even-box">
              <div className="p-lg-4">
                <a className="text-decoration-none" href="https://msamotors.in/" target="_blank">
                  <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                    <img className="img-fluid rounded-5" src={MSA} alt="" />
                  </div>
                  <div className="portfolio-text-part">
                    <h2 className="mb-3 title fw-bold fs-4 text-center">MSA MOTORS</h2>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-6  even-box">
                            <div className="p-lg-4">
                                <a className="text-decoration-none" href="https://tattvarealty.co.in/" target="_blank">
                                    <div className="portfolio-img-container p-lg-4 p-3 rounded-5 mb-4">
                                        <img className="img-fluid rounded-5" src={Tattva} alt="" />
                                    </div>
                                    <div className="portfolio-text-part">
                                        <h3 className="mb-3 title fw-bold fs-4 text-center">TATTVA REALTY & INFRA</h3>
                                    </div>
                                </a>
                            </div>
                        </div>
          </div>

          <div className='even-box'>
            {/* <!-- round button  start --> */}
            <div className="section-btn-conteiner">
              <a className="section-btn-content" href="/portfolio">
                <span className="section-btn-title text-white">Learn More</span>
                <span className="section-icon-arrow">
                  <svg
                    width="45px"
                    height="43px"
                    viewBox="0 0 66 43"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <g id="arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <path
                        id="arrow-icon-one"
                        d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                        fill="#FFFFFF"
                      ></path>
                      {/* Additional arrows */}
                      <path
                        id="arrow-icon-two"
                        d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                        fill="#FFFFFF"
                      ></path>
                    </g>
                  </svg>
                </span>
              </a>
            </div>
            {/* <!-- round button  end --> */}
          </div>
        </div>
      </section>

      {/* <!-- portfolio end  --> */}
      {/* <!-- about us section start  --> */}
      <section className="container-fluid py-5">
        <div className="container" >
          <div className="row py-lg-5">
            <div className="col-lg-5 my-3">
              <h4 className="mb-3 title fw-bold fs-4 letter-spacing-3">WHO WE ARE</h4>
              <h2 className="display-4">We're A Team Of <br /><span className="title letter-spacing-3">PER A CAUSE.</span> </h2>
              <p className="fs-5">We are a team of WordPress Developers, Webflow Developers, and UI/UX Designers. Our focus is on crafting high-performance websites with exceptional functionality and design. Every project is built to inspire and leave a lasting <span className="title">"IMPRESSION".</span> </p>
              <p className="fs-5">We specialize in SEO, social media marketing, and paid advertising, ensuring your brand gains maximum visibility and engagement.</p>

              <div className='w-md-30 w-50'>
                {/* Get Start Button */}
                <div className="btn-container">
                  <a className="btn-content cursor-pointer" href='/about'>
                    <span className="btn-title">KNOW MORE</span>
                    <span className="icon-arrow">
                      <svg
                        width="30px"
                        height="30px"
                        viewBox="0 0 66 43"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="arrow" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <path
                            id="arrow-icon-one"
                            d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                            fill="#FFFFFF"
                          ></path>
                          <path
                            id="arrow-icon-two"
                            d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                            fill="#FFFFFF"
                          ></path>
                          <path
                            id="arrow-icon-three"
                            d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                            fill="#FFFFFF"
                          ></path>
                        </g>
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-7 my-3 d-flex align-items-center justify-content-center">
              <img className="img-fluid rounded-4" src={About_Img} alt="about-img" />
            </div>
          </div>
        </div>
      </section>
      {/* <!-- about us section end  --> */}

      {/* <!-- services section start  --> */}
      <section className="container-fluid py-5 bg-light-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title-part d-flex  flex-column mb-5">
                <h3 className="mb-3 title fw-bold fs-4 letter-spacing-3">OUR SERVICES</h3>
                <h2 className=" display-4 fw-normal">We Provide Best Service To Our Clients</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 my-3">
              <a href="" className="service-card d-flex align-items-center justify-content-center flex-column rounded-5 p-3 text-decoration-none h-100">
                <img src={WebDev} className="img-fluid" alt="" />
                <h3 className="fs-5 text-white text-center mt-2">Web Design & Development</h3>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 my-3">
              <a href="" className="service-card d-flex align-items-center justify-content-center flex-column rounded-5 p-3 text-decoration-none h-100">
                <img src={Marketing} className="img-fluid" alt="" />
                <h3 className="fs-5 text-white text-center mt-2">Digital Marketing</h3>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 my-3">
              <a href="" className="service-card d-flex align-items-center justify-content-center flex-column rounded-5 p-3 text-decoration-none h-100">
                <img src={LogoDesign} className="img-fluid" alt="" />
                <h3 className="fs-5 text-white text-center mt-2">Logo Design</h3>
              </a>
            </div>
            <div className="col-lg-3 col-md-6 my-3">
              <a href="" className="service-card d-flex align-items-center justify-content-center flex-column rounded-5 p-3 text-decoration-none h-100">
                <img src={SEO} className="img-fluid" alt="" />
                <h3 className="fs-5 text-white text-center mt-2">SEO</h3>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- services section end  --> */}

      {/* <!-- clients section start  --> */}
      <section className="container-fluid py-5 client-slider">
        <div className="container">
          <div className="title-part d-flex align-items-center justify-content-center flex-column mb-5">
            <h4 className="mb-3 title fw-bold fs-4 text-center letter-spacing-3">CREATING IMPACT SINCE 2022</h4>
            <h2 className="text-center display-4 ">Proud to have served these brands with our creative solutions and expertise</h2>
          </div>
        </div>

        {/* Forward Direction Slider (First Half - No Repetition) */}
        <div className="logo-slider-container">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={4}
            loop={true}  // Ensuring loop works even with half the logos
            autoplay={{ delay: 0, disableOnInteraction: false, reverseDirection: false }}
            speed={2000}
            allowTouchMove={false}
            breakpoints={{
              0: { slidesPerView: 2 },
              600: { slidesPerView: 3 },
              1024: { slidesPerView: 5 },
            }}
          >
            {[...firstHalf, ...firstHalf].map((logo, index) => ( // Duplicating to enable smooth looping
              <SwiperSlide key={index}>
                <div className="logo-card">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Reverse Direction Slider (Second Half - Continuous Loop) */}
        <div className="logo-slider-container">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={4}
            loop={true}
            autoplay={{ delay: 0, disableOnInteraction: false, reverseDirection: true }}
            speed={2000}
            allowTouchMove={false}
            breakpoints={{
              0: { slidesPerView: 2 },
              600: { slidesPerView: 3 },
              1024: { slidesPerView: 5 },
            }}
          >
            {[...secondHalf, ...secondHalf].map((logo, index) => ( // Duplicating for a smooth loop
              <SwiperSlide key={index}>
                <div className="logo-card">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>
      {/* <!-- clients section end  --> */}
      {/* <!-- testimonial section start  --> */}

      <section className="container-fluid py-5 bg-light-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="title-part d-flex  flex-column mb-5">
                <h3 className="mb-3 title fw-bold fs-4 letter-spacing-3">TESTIMONIALS</h3>
                <h2 className=" display-4 fw-normal">Success Stories from Our Happy Clients</h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-4">
              <div className="d-flex align-items-center justify-content-center flex-column testi-left-box rounded-4 p-4">
                <h3 className="display-1 fw-medium">4.5</h3>
                <div className="star-icons">
                  <i className="fa-solid fa-star title"></i>
                  <i className="fa-solid fa-star title"></i>
                  <i className="fa-solid fa-star title"></i>
                  <i className="fa-solid fa-star title"></i>
                  <i className="fa-solid fa-star-half-stroke title"></i>
                </div>
                <p>(30+ Happy Clients)</p>
                <h4 className="text-center">Customer experiences that speak for themselves</h4>

              </div>
            </div>
            <div className="col-lg-8 p-lg-5 p-md-4 p-3">
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
                spaceBetween={20}
                slidesPerView={1}
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                speed={800}
              >
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <div className="testi-card transition-transform duration-500 ease-in-out">
                      <p className="fs-4 fs-sm-5 mb-5">{testimonial.text}</p>
                      <div>
                        <h4>{testimonial.name}</h4>
                        <p>{testimonial.company}</p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="d-flex align-items-center justify-content-center gap-5 testi-arrows">
                <i className="fa-solid fa-arrow-left p-3 rounded-4 fs-4 swiper-button-prev"></i>
                <i className="fa-solid fa-arrow-right p-3 rounded-4 fs-4 swiper-button-next"></i>
              </div>
            </div>
            {/*  */}

            {/*  */}
          </div>
        </div>
      </section>

      {/* <!-- testimonial section end  --> */}
      {/* <!-- blog section start  --> */}

      <section className="container-fluid blog-section py-5">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-6">
              <div className="title-part d-flex  flex-column mb-4">
                <h5 className="mb-3 title fw-bold fs-4 letter-spacing-3">BLOGS</h5>
                <h2 className=" display-4 fw-normal">Insights on digital innovation and growth</h2>
              </div>
            </div>
            <div className="col-lg-6">
              {/* <!-- round button  start -->
              <!-- <div className="section-btn-conteiner position-absolute">
                <a className="section-btn-content" href="#">
                  <span className="section-btn-title text-white">Get Start</span>
                  <span className="section-icon-arrow">
                    <svg width="45px" height="43px" viewBox="0 0 66 43" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <path id="arrow-icon-one"
                          d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
                          fill="#FFFFFF"></path>
                        <path id="arrow-icon-two"
                          d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
                          fill="#FFFFFF"></path>
                        <path id="arrow-icon-three"
                          d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
                          fill="#FFFFFF"></path>
                      </g>
                    </svg>
                  </span>
                </a>
              </div> -->
              <!-- round button  end --> */}
            </div>
          </div>

          {/*  */}
          <div className="col-lg-12 mt-5">
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              }}
              spaceBetween={20}
              slidesPerView={3} // Show 3 slides at a time
              loop={true} // Infinite loop
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              speed={800}
              breakpoints={{
                320: { slidesPerView: 1 }, // 1 slide on small screens
                768: { slidesPerView: 2 }, // 2 slides on medium screens
                1024: { slidesPerView: 3 }, // 3 slides on large screens
              }}
            >
              {/* Repeated Blog Card Slides */}
              {repeatedBlogs.map((blog, index) => (
                <SwiperSlide key={index}>
                  <a href="#" className="blog-box d-flex align-items-center justify-content-center flex-column rounded-4 text-decoration-none h-100">
                    <img src={blog.img} className="img-fluid rounded-4" alt="" />
                    <h3 className="title p-3 fs-4">{blog.title}</h3>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Navigation Arrows */}
            <div className="d-flex align-items-center justify-content-center gap-5 testi-arrows mt-4">
              <i className="fa-solid fa-arrow-left p-3 rounded-4 fs-4 swiper-button-prev"></i>
              <i className="fa-solid fa-arrow-right p-3 rounded-4 fs-4 swiper-button-next"></i>
            </div>
          </div>

          {/*  */}

        </div>
      </section>
      {/* <!-- blog section end  --> */}

      {/* Theme Toggle Button */}
      {/* Uncomment below if needed */}
      {/* <button onClick={toggleTheme} className="theme-toggle-btn">Toggle Theme</button> */}
    </div >
  );
}

export default Home;
